import type {
	AnalystsEstimatesChartTimeFrame,
	AnalystsEstimatesChartViewMode,
	TableColumn,
} from "@/components/widgets/Revision/types";

export const filterData = (
	data: TableColumn[][],
	estimatesValue: AnalystsEstimatesChartViewMode,
	timeFrameType: AnalystsEstimatesChartTimeFrame,
) => {
	return data.filter((ee) =>
		ee.some((e) => e.type === timeFrameType && e[estimatesValue]),
	);
};
